module.exports = __webpack_public_path__ + "static/img/info_stage2.82715c8.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/info_stage2.png
// module id = 6ajT
// module chunks = 1